module.exports = {
    analyticsOnLoadLNG316: true,
    popularItemsOnODPLNG303: false,
    analyticsInteractionsLNG316: true,
    analyticsViewOfferLNG317: true,
    viewSelectedCharityOnCPPLNG396: true,
    charityFlyoutforChosenCharityLNG415: true,
    analyticsViewRewardsLNG320: true,
    lng_166_charity_selection: true, // eslint-disable-line camelcase
    lng_399_authenticateForCharitySelection: true, // eslint-disable-line camelcase
    lng_399_select_a_charity: true, // eslint-disable-line camelcase
    lng_400_select_all_charities: true, // eslint-disable-line camelcase
    authenticateUserLNG395: true,
    charityFlyoutforAllCharitiesLNG246: true,
    charityFlyoutWithoutStoriesLNG567: true,
    analyticsLinkNewCardLNG319: true,
    landingPageBannerContentLNG326: true,
    landingVideoContentLNG430: true,
    analyticsScanCardLNG318: true,
    analyticsScanAndShopLNG1586: true,
    analyticsBenefitThumbnailsLNG1534: true,
    analyticsAdventCalendarOffersLNG1613: true,
    landingAppDownloadContentLNG432: true,
    landingPageButtonsLNG433: true,
    sparksBenefitsLNG431: true,
    joinSparksAuthenticationLNG158: true,
    analyticsCharityPageLNG417: true,
    loyaltyProfileAndHubRedirectionLNG439: true,
    marketingPreferencesToggleLNG438: false,
    centraliseOffersLNG509: true,
    welcomeJourneyExistingUserLNG475: true,
    charityDonationEmptyStateLNG554: true,
    guestUserRedirectLNG429: true,
    hubAppDownloadBanner: true,
    markWelcomJournyCompleteLNG479: true,
    welcomeJourneyNewUserLNG476: true,
    markWJCompleteOnLinkLNG604: true,
    integrateCharityStoriesFlyoutLNG526: true,
    analyticsLandingPageLNG462: true,
    aboutPageMobileSectionLNG607: true,
    discoverSparksBannerLNG481: true,
    charitySettingsAnchorLNG619: true,
    isaJourneyLNG654: true,
    appOnlyBannerFooterTextLNG642: true,
    pickTreatCardLNG692: true,
    sparksCardMobileWidthLNG701: true,
    expandHiddenCardLNG713: true,
    offersAndCardDockingAtTopLNG585: true,
    bookSlotLNG779: true,
    holdingPageLNG808: true,
    congratulationsPopupMCLY1461: true,
    thousandXmasVoucherMCLY1462: true,
    reoptinLNG657: false,
    addressCaptureBannerLNG776: true,
    christmasAnalyticsMCLY1607: true,
    shoppingForAYearMCLY1458: true,
    sfyNotificationToCustomerMCLY1454: true,
    sfyCongratulationsToCustomerMCLY1453: false,
    verifyCustomerShoppingForAYearMCLY1452: true,
    sfyAnalyticsMCLY1608: true,
    referAFriendLNG903: true,
    promptDigitalReceiptsLNG716: true,
    promptSparksConsentLNG714: true,
    promptMarketConsentLNG715: true,
    streakOffersMCLY1748: true,
    analyticsStreakOfferMCLY1584: true,
    analyticsSpendAndSaveMCLY1892: true,
    streakOfferPlayback1StampMCLY1679: true,
    streakOfferPlaybackCongratulationsMCLY1680: true,
    reusableBannersMCLY1790: true,
    limitHubTo2RandomBannersMCLY1790: true,
    analyticsForBannersMCLY1788: true,
    charityFootnoteMCLY1717: true,
    qrTreatNotificationLNG1121: true,
    qrTreatPopUpLNG1160: true,
    rafTreatNotificationLNG995: true,
    newOffersAdviceTextOneLNG1117: true,
    streakSASFirstPurchasePopupMCLY1941: true,
    sasCongratulationsPopupMCLY1942: true,
    qrAlertPopUpLNG1263: true,
    campaignTreatLNG1229: true,
    mnsOffersCarouselLNG1320: true,
    assistanceLNG1353: true,
    alwaysOnCoffeeAppOnlyMCLY2286: true,
    instantWinnerPopupLNG1350: true,
    captureDateOfBirthLNG1472: true,
    checkPlutoLNG1487: false,
    showCharityDonatedSectionSROI249: true,
    showCharityCategorySROI419: true,
    sparksThumbnailsLNG1551: true,
    reskinLNG1561: true,
    linkPhysicalCardSROI516:true,
    freeDeliveryNGS: true,
    welcomeSlideCardImageSROI429:true,
    analyticsEreceiptPageLNG1557: true,
    analyticsAboutSparksPageLNG1596: true,
    analyticsReferralPageLNG1596: true,
    hubPageShowCardFront: true,
    welcomeOfferPromptSpikeLNG1635: false,
    sparksAppDownloadLNG1664: false,
    eReceiptsPromptLNG1637: true,
    charityPromptLNG1666: true,
    welcomeOfferPromptLNG1663: true,
    analyticsWelcomeOfferPromptLNG1636: true,
    appDownloadElementLNG1665: false,
    curalateSparksLNG1728: true,
    appDownloadBannerLNG1743: false,
    sparksAboutUsRoiLNG1780: true,
    marchLoveLNG1854: false,
    showPaidDeliveryBanner: true,
    profileCompletionLNG1865: true,
    countdownBannerMCLY2754: false,
    instantWinBannerLNG1726: true,
    productPagePopUp: false,
    paidDeliveryPostPurchaseBanner: true,
    paidDeliveryPassTempAllocation: false,
    offerInteractionLNG1871: true,
    showMyRewards: true,
    voucherTilesSPDR285: true,
    myRewardsTabSPDR294: false,
    myRewardsSettingSPDR281: false,
    digiRewardsTokenSPDR397: true,
    bonusOffersSPDR400: true,
    restructureV1LNG1965: true,
    offerRejectionLNG1809:false,
    showAppOnlyOfferBanner: true,
    projectManeLNG1994: false,
    showSparksPlusTopBanner: false,
    enableSparksPlus: false,
    digitalReceiptsLNG1998:true,
    maneEndBanner:true,
    hubOrchestrationApiLNG2153:true,
    sparksAdventCalendarMCLY2943: false,
    sparksAdventCalendarPopUpMCLY2957: true,
    analyticsACMCLY3006:true,
    registrationOrchestrationApi:true,
    reOptinLNG2171:true,
    sparksOfferWallet: true,
    updateOfferStatusLNG2169:true,
    sparksPlusAppointmentService: true,
    preferenceApiLNG2188:true,
    enableCiamSPDR319: true,
    showCancelDpButton: false,
    POSCampaignLNG2200: true,
    accDetailsFlyoutSPDR495: true,
    enableMoreInfoSPDR505: true,
    qrScreenLNG2183:true,
    optinLNG2170:true,
    creditCardRewardsBranding: true,
    joinSparksBanner2259: true,
    captureNumberBannerLNG2062:false,
    digitalReceiptPopupLNG2272: true,
    markDigitalreceiptJourneyCompleteLNG2273:true,
    useMSAuthTokenSPDR508: true,
    drLandingPageNoVideo: false,
    deliveryPassRetention: true,
    deliveryPassAquisition: true,
    walletButtonsLNG2266: true,
    prizeDrawCMPN24: true,
    showSupportAllCharitiesButton: true,
    adventCalendar2023: true
};
